import {
  fadeIn,
  fadeInDown,
  fadeInRight,
  rotateInDownRight,
  rotateInUpLeft,
  zoomIn,
  bounceIn,
} from "react-animations";
import styled, { keyframes } from "styled-components";

// Default time if none is provided via props
const defaultTime = "0.5s";

export const BouncyDiv = styled.div`
  animation: ${props => props.time || defaultTime} ${keyframes`${fadeInRight}`};
`;

export const RotateInDownRightDiv = styled.div`
  animation: ${props => props.time || defaultTime} ${keyframes`${rotateInDownRight}`};
`;

export const RotateInUpLeftDiv = styled.div`
  animation: ${props => props.time || defaultTime} ${keyframes`${rotateInUpLeft}`};
`;

export const FadeIntDiv = styled.div`
  animation: ${props => props.time || defaultTime} ${keyframes`${fadeIn}`};
`;

export const FadeInt2Div = styled.div`
  animation: ${props => props.time || defaultTime} ${keyframes`${fadeIn}`};
`;

export const FadeInt3Div = styled.div`
  animation: ${props => props.time || defaultTime} ${keyframes`${fadeIn}`};
`;

export const FadeInDownDiv = styled.div`
  animation: ${props => props.time || "0.1s"} ${keyframes`${fadeInDown}`};
`;

export const ZoomIn1 = styled.div`
  animation: ${props => props.time || defaultTime} ${keyframes`${zoomIn}`};
`;

